import { render, staticRenderFns } from "./pape_do.vue?vue&type=template&id=49f9581b&scoped=true&"
import script from "./pape_do.vue?vue&type=script&lang=js&"
export * from "./pape_do.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f9581b",
  null
  
)

export default component.exports